// File: src/components/FrostedGlassBackdrop.js
import React from 'react';
import { motion } from 'framer-motion';

const FrostedGlassBackdrop = () => {
  return (
    <motion.div
      key="frosted-glass-backdrop"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.22, ease: "easeInOut" }}
      className="absolute inset-0 pointer-events-none"
      style={{
        background: 'linear-gradient(to top, rgba(20, 20, 20, 0.75), transparent)',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        maskImage: "linear-gradient(to top, black 90%, transparent 100%)",
        WebkitMaskImage: "linear-gradient(to top, black 60%, transparent 100%)",
      }}
    />
  );
};

export default FrostedGlassBackdrop;